<template>
  <div class="settings container d-flex flex-column justify-content-center bg-white p-4">
    <div class="h5 d-flex align-items-center">
      <b-button variant="link" @click="goBack" class="p-0">
        <span class="material-icons mr-2">arrow_back</span>
      </b-button>
      {{ $t("spraying.settingsTitle") }}
    </div>
    <b-list-group flush class="py-4">
      <b-list-group-item class="px-0">
        <b-row class="align-items-center">
          <b-col cols="7" class="d-flex align-items-start justify-content-start">
            <span class="material-icons mr-1">shower</span>
            <div>
              <label for="sprayRate" class="font-weight-bold mb-1">{{ $t("settings.sprayRate")}}</label>
              <p>{{ $t("settings.sprayRateDescription") }}</p>
            </div>
          </b-col>
          <b-col>
            <b-form-input
              type="number"
              :value="sprayRate"
              @change="updateSprayRate"
              class="text-center bg-light border-0"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item class="px-0">
        <b-row class="align-items-center">
          <b-col cols="7">
            <label
              for="shouldPathBeSprayed"
              class="font-weight-bold mb-1"
            >{{ $t("settings.shouldPathBeSprayed")}}</label>
          </b-col>
          <b-col class="text-right">
            <b-form-checkbox
              switch
              class="form-check-input"
              id="shouldPathBeSprayed"
              :checked="shouldPathBeSprayed"
              @change="updatePathShouldBeSprayed"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item class="px-0">
        <b-row class="align-items-center">
          <b-col cols="7">
            <label
              for="confirmationCheck"
              class="font-weight-bold mb-1"
            >{{ $t("settings.ask_for_confirmation")}}</label>
          </b-col>
          <b-col class="text-right">
            <b-form-checkbox
              switch
              class="form-check-input"
              id="confirmationCheck"
              :checked="confirmationRequired"
              @change="updateConfirmationRequired"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SprayingSettings",
  props: ["id"],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      sprayRate: state => state.sprayRate,
      shouldPathBeSprayed: state => state.shouldPathBeSprayed,
      confirmationRequired: state => state.confirmationRequired
    })
  },
  methods: {
    updateSprayRate(value) {
      this.$store.dispatch("sprayRateAction", value);
    },
    updatePathShouldBeSprayed(value) {
      this.$store.dispatch("shouldPathBeSprayedAction", value);
    },
    updateConfirmationRequired(value) {
      this.$store.dispatch("confirmationRequired", value);
    },
    goBack() {
      this.$router.push({ path: "/spraying/" + this.id });
    }
  }
};
</script>

<style scoped>
.title {
  margin-top: 20px;
  text-align: center;
  font-size: 30px;
}
.close-button {
  margin-top: 20px;
  text-align: center;
}
.arrows {
  font-size: 50px;
}
.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03),
    0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03),
    0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05),
    0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
  border-width: 0;
  transition: all 0.2s;
}
</style>